<!--  -->
<template>
  <div>
    <!-- <el-form ref="formData" label-width="96px" :model="formData" :rules="rules"> -->
    <el-form label-width="96px" :model="formData">
      <!-- <el-form-item label="小程序名称" prop="name"> -->
      <el-form-item label="小程序名称">
        <el-input v-model.trim="formData.name" style="width: 300px;" />
      </el-form-item>
      <!-- <el-form-item label="APPID" prop="appid"> -->
      <el-form-item label="APPID">
        <el-input v-model.trim="formData.appid" style="width: 300px;" />
      </el-form-item>
      <el-form-item label="ghid">
        <el-input v-model.trim="formData.gh_id" style="width: 300px;" />
      </el-form-item>
      <el-form-item>
        <!-- <el-button type="primary" @click="submitForm('formData')">提交</el-button> -->
        <el-button type="primary" @click="submitForm">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addProgram } from '@/api/templatelist.js'
export default {
  components: { },
  data() {
    // const validateappid = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入APPID'))
    //   } {
    //     const urlregex = /^[0-9a-zA-Z]*$/g
    //     if (!urlregex.test(value)) {
    //       callback(new Error('APPID格式不正确！'))
    //     } else {
    //       callback()
    //     }
    //   }
    // }
    return {
      formData: {
        name: '',
        appid: '',
        gh_id: ''
      },
      rules: {
        name: [{ max: 20, message: '长度不能超过20个字符', trigger: 'blur' }]
        // appid: [{ max: 20, message: '长度不能超过20个字符', trigger: 'blur' }, { validator: validateappid, trigger: 'blur' }]
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async submitForm(formName) {
      if (this.formData.name === '') {
        this.$message.error('请输入小程序名称')
        return
      }
      if (this.formData.appid === '') {
        this.$message.error('请输入APPID')
        return
      }
      if (this.formData.gh_id === '') {
        this.$message.error('请输入ghid')
        return
      }
      // this.$refs[formName].validate(async(valid) => {
      //   if (valid) {
      //     const data = await addProgram({ name: this.formData.name, app_id: this.formData.appid })
      //     console.log('data----add', data)
      //     if (data.code === 200) {
      //       this.$message.success('新建成功')
      //       this.$emit('addprogram')
      //     }
      //   } else {
      //     console.log('error submit!!')
      //     return false
      //   }
      // })
      const data = await addProgram({ name: this.formData.name, app_id: this.formData.appid, gh_id: this.formData.gh_id })
      console.log('data----add', data)
      if (data.code === 200) {
        this.$message.success('新建成功')
        this.$emit('addprogram')
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
